import { Logout } from "../../Logout";
import Footer from "../Footer";
import Menu from "../Menu";
import useCommonLayout from "./useCommonLayout";

const CommonLayout = ({ children }) => {
  const { modeCokkie } = useCommonLayout();
  return (
    <>
      {modeCokkie !== "app" && <Menu />}
      <div className="switcher">
        <Logout />
        {children}
      </div>
      {modeCokkie !== "app" && <Footer />}
    </>
  );
};

export default CommonLayout;
